// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--3OEox","spin":"style-module--spin--LcGYJ"};